export default __webpack_public_path__ + "static/media/1.af2fb7a2.jpg";